<div class="modal-header">
  <h4 class="modal-title">Delete {{ subjectNoun }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="alert alert-danger" role="alert" *ngIf="bookingWarning">
    {{ bookingWarning }}
  </div>

  <div class="alert alert-warning" role="alert">
    Deleting {{ getSubjectDescription() }} will leave the following
    {{ remainingEvents.length === 1 ? 'event' : 'events' }} in place, because
    {{ remainingEvents.length === 1 ? remainingReasonSingular : remainingReasonPlural }}.
    {{ remainingEvents.length === 1 ? 'This event' : 'These events' }} will no
    longer be associated with any schedule.
  </div>

  <table class="table table-sm">
    <thead>
      <tr>
        <th>Event</th>
        <th>When</th>
        <th>Location</th>
        <th class="text-right">Reservations</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let event of remainingEvents">
        <td>{{ getEventNameDisplay(event) }}</td>
        <td class="text-nowrap">
          {{ dateStringFromISO8601(event.start_datetime, event.time_zone) }},
          {{ timeStringFromISO8601(event.start_datetime, event.time_zone) }}
        </td>
        <td>{{ event.location_name }}</td>
        <td class="text-right">{{ event.num_active_reservations }}</td>
        <td class="text-right">
          <a class="btn btn-sm btn-outline-primary text-nowrap"
             [routerLink]="['/events/scheduled/now/event', event.event_part_id]"
             target="_blank">
            View event
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Cancel
  </button>
  <button type="button" class="btn btn-danger"
          (click)="handleConfirm()"
          [class.disabled]="confirming"
          [disabled]="confirming">
    {{ confirming ? 'Loading...' : 'Delete Anyway' }}
  </button>
</div>
